import React from "react";
import styled, { keyframes } from "styled-components";
import { ITheme } from "../Themes/ThemeTypes";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Circle = styled.svg<{ theme: ITheme; $size: number }>`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  animation: ${spin} 1s linear infinite;
  color: rgb(${(props) => props.theme.colors.primary});
`;

interface ProgressIndicatorProps {
  size?: number;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ size = 24 }) => (
  <Circle $size={size} viewBox="0 0 50 50">
    <circle
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeDasharray="90 150"
      strokeDashoffset="-35"
    />
  </Circle>
);

export default ProgressIndicator;
